<template>
  <v-card class="mb-4">
    <v-card-text>
      <div class="d-flex flex-wrap align-center justify-space-between">
        <div>
          <div class="text-h3 mb-1">
            {{ filial.name }}
          </div>
          <div class="grey--text mb-3">
            {{ filial.regionName || '—' }} · {{ filial.organizationName || '—' }}
          </div>

          <v-chip :color="filial.isConnected ? 'success' : 'error'" dark>
            {{ connectionLabel }}
          </v-chip>
        </div>

        <div class="d-flex align-center">
          <v-btn
            v-if="canReadGuide"
            :href="guideUrl"
            target="_blank"
            rel="noopener"
            color="primary"
            outlined
            class="mr-4"
          >
            <v-icon left>
              mdi-book-open-variant
            </v-icon>
            Инструкция
          </v-btn>

          <v-btn
            v-if="canConnect"
            color="primary"
            :loading="connecting"
            @click="showDialog = true"
          >
            Подключить
          </v-btn>
        </div>
      </div>
    </v-card-text>

    <primary-confirm-dialog
      v-model="showDialog"
      title="Подключить филиал к FAKT.CRM?"
      :loading="connecting"
      @confirm="connect"
    >
      <template #subtitle>
        Филиал «{{ filial.name }}» будет отмечен как подключённый, датой подключения станет сегодняшняя.
        Убедитесь, что оборудование настроено и проверено.
      </template>
    </primary-confirm-dialog>
  </v-card>
</template>

<script>
  import PrimaryConfirmDialog from '@/components/ui/dialogs/PrimaryConfirmDialog.vue'
  import snackbarMessage from '@/mixins/snackbar-message'
  import CRMPermission from '@/models/enums/permissions/CRMPermission'
  import RouteName from '@/models/enums/RouteName'
  import filialsApi from '@/api/filials'

  export default {
    name: 'FilialConnectionStatus',
    components: { PrimaryConfirmDialog },
    mixins: [snackbarMessage],
    props: {
      filial: { type: Object, required: true },
    },
    data () {
      return {
        showDialog: false,
        connecting: false,
      }
    },
    computed: {
      canReadGuide () {
        return this.userCan(CRMPermission.KnowledgeBaseFilialConnection)
      },
      // Инструкция открывается в соседней вкладке: карточку подключения не теряем
      guideUrl () {
        return this.$router.resolve({ name: RouteName.KnowledgeBaseFilialConnection }).href
      },
      canConnect () {
        return !this.filial.isConnected && this.userCan(CRMPermission.ConnectFilial)
      },
      connectionLabel () {
        if (!this.filial.isConnected || !this.filial.connectionDate) return 'Не подключён'

        const date = new Date(Date.parse(this.filial.connectionDate)).toLocaleDateString('ru-RU')
        return `Подключён ${date}`
      },
    },
    methods: {
      async connect () {
        this.connecting = true
        try {
          await filialsApi.connect(this.filial.id)
          this.showSuccessMessage('Филиал подключён')
          this.$emit('updated')
        } catch (e) {
          this.showErrorFromResponse(e)
        }
        this.connecting = false
        this.showDialog = false
      },
    },
  }
</script>
